import {
  IconCar,
  IconCreditCard,
  IconGift,
  IconGiveMoney,
  IconId,
  IconPercent,
  IconPix,
  IconPlane,
  IconTrendingUp,
  IconUser,
} from '@consumidor-positivo/aurora';

export const categoryFilter = [
  {
    title: 'Cartões',
    slug: 'cards',
    benefitFilterText: 'O que você prefere em um cartão?',
  },
  {
    title: 'Empréstimos',
    slug: 'loans',
    benefitFilterText: 'Que tipo de empréstimo você procura?',
  },
  {
    title: 'Consórcio',
    slug: 'consorcio',
  },
  {
    title: 'Contas',
    slug: 'account',
  },
  {
    title: 'Todas as ofertas',
    slug: 'all',
  },
];

export const benefitFilter = {
  cards: [
    {
      title: 'Pré-aprovado',
      slug: 'pre_approved',
      icon: <IconTrendingUp />,
    },
    {
      title: 'Anuidade zero',
      slug: 'zero_annuity',
      icon: <IconPercent />,
    },
    {
      title: 'Milhas e pontos',
      slug: 'miles',
      icon: <IconPlane />,
    },
    {
      title: 'Cashback',
      slug: 'cashback',
      icon: <IconGift />,
    },
    {
      title: 'Ver todos',
      slug: 'all',
      icon: <IconCreditCard />,
    },
  ],
  loans: [
    {
      title: 'Pessoal',
      slug: 'personal',
      icon: <IconPercent />,
    },
    {
      title: 'Com garantia',
      slug: 'assurance',
      icon: <IconCar />,
    },
    {
      title: 'Consignado',
      slug: 'consigned',
      icon: <IconId />,
    },
    {
      title: 'Para PJ',
      slug: 'pj',
      icon: <IconUser />,
    },
    {
      title: 'Receba no dia',
      slug: 'quick_received',
      icon: <IconPix />,
    },
    {
      title: 'Ver todos',
      slug: 'all',
      icon: <IconGiveMoney />,
    },
  ],
};

export const rejectedOfferMap = {
  'loans-facio-ep': {
    title: 'Seu pedido de empréstimo na Facio não foi aprovado no momento',
    message: 'Mas veja abaixo outras opções que selecionamos para você',
  },
  'loans-facio-eptest': {
    title: 'Seu pedido de empréstimo na Facio não foi aprovado no momento',
    message: 'Mas veja abaixo outras opções que selecionamos para você',
  },
};
